<template>
  <div v-loading="true" />
</template>

<script>
export default {
  async mounted () {
    await this
      .$session
      .terminate()

    this
      .$router
      .replace({ name: 'application' })
  }
}
</script>

<style lang="scss" scoped>
  div:first-of-type {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 10vw;
  }
</style>
